import React, { useState, useEffect } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts/highstock'
import baseServices from '../../../services/base.services'

const BalanceS = ({ body, height, name }) => {

    const [state, setState] = useState(null)

    // Arsenito
    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getDataTostacionDMH2(body)
                if (response.data && response.data.length > 0) {
                    let arrayValor1 = [], arrayValor2 = [], arrayValor3 = [], arrayValor4 = []

                    // console.log(response.data)

                    response.data.forEach((x, i) => {
                        arrayValor1.push(x.Fecha)
                        arrayValor2.push(x.EntradasS)
                        arrayValor3.push(x.SalidasS)
                        arrayValor4.push(x.Desviacion)
                    })

                    if (arrayValor1.length > 0 && arrayValor2.length && arrayValor3.length && arrayValor4.length) {

                        setState({
                            chart: {
                                zoomType: 'xy',
                                backgroundColor: '#404040'
                            },
                            title: {
                                text: ''
                            },
                            // subtitle: {
                            //     text: 'Source: WorldClimate.com'
                            // },
                            xAxis: [
                                {
                                    categories: arrayValor1,
                                    // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                    crosshair: true,
                                    labels: { style: { color: 'white' } },
                                }
                            ],
                            yAxis: [
                                { // 1 yAxis
                                    labels: {
                                        format: '{value}',
                                        style: {
                                            color: 'white'
                                        }
                                    },
                                    title: {
                                        text: '',
                                        style: {
                                            color: 'white'
                                        }
                                    },
                                    gridLineWidth: 0,
                                },
                                { // 2 yAxis
                                    title: {
                                        text: '',
                                        style: {
                                            color: 'white'
                                        }
                                    },
                                    labels: {
                                        format: '{value}',
                                        style: {
                                            color: 'white'
                                        }
                                    },
                                    opposite: true,
                                    gridLineWidth: 0,
                                },
                                { // 3 yAxis
                                    title: {
                                        text: '',
                                        style: {
                                            color: 'white'
                                        }
                                    },
                                    labels: {
                                        format: '{value}',
                                        style: {
                                            color: 'white'
                                        }
                                    },
                                    opposite: true
                                }
                            ],
                            tooltip: {
                                shared: true
                            },
                            legend: {
                                layout: 'vertical',
                                align: 'left',
                                x: 30,
                                verticalAlign: 'top',
                                y: -10,
                                floating: true,
                                backgroundColor: 'rgba(255,255,255,0.25)',
                            },
                            series: [
                                {
                                    zIndex: 0,
                                    name: 'Entradas S',
                                    type: 'column',
                                    data: arrayValor2,
                                    // data: [3.0, 2.9, 2.5, 10.5, 8.2, 1.5, 5.2, 6.5, 3.3, 8.3, 3.9, 9.6],
                                    tooltip: {
                                        valueSuffix: ''
                                    },
                                    color: '#1792e5'
                                },
                                {
                                    zIndex: 1,
                                    name: 'Salidas S',
                                    type: 'column',                                    
                                    data: arrayValor3,
                                    // data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
                                    tooltip: {
                                        valueSuffix: ''
                                    },
                                    color: '#7eb338'
                                },
                                {
                                    zIndex: 2,
                                    name: 'Desviación',
                                    type: 'spline',
                                    yAxis: 1,
                                    data: arrayValor4,
                                    // data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9, 9.6],
                                    tooltip: {
                                        valueSuffix: ''
                                    },
                                    color: '#f37021',
                                    lineWidth: 4
                                }
                            ],
                            credits: {
                                enabled: false
                            }
                        })
                    }
                    setTimeout(() => { getTTeg() }, 60000)
                }
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }

        getTTeg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {
                state ?
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={state}
                        containerProps={{ style: { height: height, width: '100%' } }}
                    />
                    :
                    <div className='letter-origin'>...No hay datos</div>
            }

        </>
    )
}

export default BalanceS